(function () {
  'use strict';
  var root = document.querySelector('[data-hbc-feedback]');
  if (!root) return;
  var form = root.querySelector('[data-feedback-form]');
  var message = root.querySelector('[data-feedback-message]');
  var params = new URLSearchParams(window.location.search);
  var bookingId = params.get('booking') || '';
  var token = params.get('token') || '';
  var button = form.querySelector('button[type="submit"]');

  if (!bookingId || !token) {
    button.disabled = true;
    button.hidden = true;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!form.reportValidity() || button.disabled) return;
    var data = new FormData(form);
    var payload = {
      type: 'class-feedback', bookingId: bookingId, token: token,
      overallRating: data.get('overallRating'), coachingRating: data.get('coachingRating'),
      intensity: data.get('intensity'), welcomeSafety: data.get('welcomeSafety'),
      bestPart: data.get('bestPart') || '', couldImprove: data.get('couldImprove') || '',
      recommendScore: data.get('recommendScore'), mayContact: data.get('mayContact') === 'on'
    };
    button.disabled = true;
    button.textContent = 'Sending...';
    message.classList.remove('is-error');
    message.textContent = 'Saving your feedback securely...';
    fetch(root.dataset.apiUrl, {
      method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload), redirect: 'follow', credentials: 'omit'
    }).then(function (response) {
      if (!response.ok) throw new Error('request-failed');
      return response.json();
    }).then(function (result) {
      if (!result || result.ok !== true) throw new Error(result && result.message || 'not-saved');
      form.reset();
      message.textContent = result.message || 'Thank you. Your feedback has been received.';
      button.textContent = 'Feedback Sent';
    }).catch(function () {
      message.textContent = 'Your feedback could not be saved. Check your connection and try again.';
      message.classList.add('is-error');
      button.disabled = false;
      button.textContent = 'Send Private Feedback';
    });
  });
})();
